import React from 'react';
import { Form, Table, Select, Row, Col } from 'antd';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';
import globalFormItemLayout from 'components/Portal/formItemLayout';
import axios from 'axios';

import apiPath from 'apiPath';

class AssignRole extends React.Component {

    state = {
        Users: [],
        Roles: []
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.form.validateFields((err, values) => {
            axios.put(apiPath + '/adminRole/assignRole', values, { withCredentials: true }).then(result => {
                this.getAssignedRoles();
            })
        });
    }

    getAdminUsers = () => {
        axios.get(apiPath + '/adminRole/listAdminUsers').then(users => {
            this.setState({
                Users: users.data
            })
        })
    }

    getAssignedRoles = () => {
        axios.get(apiPath + '/adminRole/listAssignedRoles').then(roles => {
            this.setState({
                Roles: roles.data
            })
        })
    }

    componentDidMount() {
        this.getAdminUsers();
        this.getAssignedRoles();
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        let columns = [
            { title: 'Name', dataIndex: 'Name' },
            { title: 'Role', dataIndex: 'Role' }
        ];

        return (
            <Form onSubmit={this.handleSubmit}>
                <Row style={{ paddingTop: '10pt' }}>
                    <Col span={10}>
                        <Form.Item>
                            {getFieldDecorator('email', {
                                initialValue: ''
                            })(
                                <Select style={{ width: '50%', marginTop: '20px', marginLeft: '10px' }} placeholder="Select Name">
                                    {this.state.Users.map(user =>
                                        <Select.Option key={user.email} value={user.email}>{user.email}</Select.Option>
                                    )}
                                </Select>
                            )}
                        </Form.Item>
                        <Form.Item>
                            {getFieldDecorator('role_id', {
                                initialValue: ''
                            })(
                                <Select style={{ width: '50%', marginLeft: '10px' }} placeholder="Select Role">
                                    {this.props.Roles.map(role =>
                                        <Select.Option key={role.id} value={role.id}>{role.name}</Select.Option>
                                    )}
                                </Select>
                            )}
                        </Form.Item>
                        <SaveButton style={{ paddingLeft: '10pt' }} />
                    </Col>
                    <Col span={10}>
                        <Table
                            bordered
                            size="medium"
                            dataSource={this.state.Roles.map(roles => {
                                return {
                                    'Name': roles.email,
                                    'Role': roles.name
                                }
                            })}
                            style={{ backgroundColor: 'white', width: '100%', marginTop: '10px' }}
                            rowKey="Name"
                            columns={columns} />
                    </Col>
                </Row>
            </Form>
        )
    }
}

export default withSpin(Form.create()(AssignRole));



// WEBPACK FOOTER //
// ./portal-components/Portal/AdminRole/AssignRole.jsx